/**
 * homePrefix: string; // 303 新划分 cyy-home-service
 * userPrefix: string; // 303 新划分 cyy-user-service
 * voucherPrefix: string; // 303之前已经划分 cyy-voucher-service
 * showPrefix: string; // 303 新划分 cyy-show-service
 * tradePrefix: string; // 303 新划分 cyy-trade-service
 * buyerPrefix: string; // 303 之前最大服务
 */
export class BaseService{
  homePrefix: string; // 303 新划分 cyy-home-service
  userPrefix: string; // 303 新划分 cyy-user-service
  voucherPrefix: string; // 303之前已经划分 cyy-voucher-service
  showPrefix: string; // 303 新划分 cyy-show-service
  tradePrefix: string; // 303 新划分 cyy-trade-service
  buyerPrefix: string; // 303 之前最大服务
  constructor() {
    this.homePrefix = '/cyy_gatewayapi/home';
    this.userPrefix = '/cyy_gatewayapi/user';
    this.voucherPrefix = '/cyy_voucherapi';
    this.showPrefix =  '/cyy_gatewayapi/show';
    this.tradePrefix = '/cyy_gatewayapi/trade';
    this.buyerPrefix = '/cyy_buyerapi';
  }
}
